export default "__VITE_ASSET__CvTfBphv__"